'use client';

import { useEffect, useRef, useState } from 'react';
import { Breakpoints, useMediaQuery } from '@/app_lib/hooks/useMediaQuery';

export function useHandheldTap({
  onTapped,
  onTappedOutside,
}: {
  onTapped?: () => void;
  onTappedOutside?: () => void;
} = {}) {
  const isHandheld = useMediaQuery(Breakpoints.Handheld) ?? false;
  const ref = useRef<HTMLDivElement | null>(null);
  const [tapped, setTapped] = useState(false);

  useEffect(() => {
    if (!isHandheld) {
      setTapped(false);
    }
  }, [isHandheld]);

  useEffect(() => {
    if (!tapped) {
      return;
    }
    const onPointerDown = (e: PointerEvent) => {
      if (ref.current?.contains(e.target as Node)) {
        return;
      }
      setTapped(false);
      onTappedOutside?.();
    };
    document.addEventListener('pointerdown', onPointerDown, true);
    return () => document.removeEventListener('pointerdown', onPointerDown, true);
  }, [tapped, onTappedOutside]);

  const onContainerPointerDown = (e: React.PointerEvent<HTMLDivElement>) => {
    if (!isHandheld) {
      return;
    }

    const { target } = e;
    if (!(target instanceof Element)) {
      return;
    }
    // Prevent tapping on interactive elements from toggling the tapped state
    if (target.closest('a, button, [role="button"]')) {
      return;
    }

    if (!tapped) {
      setTapped(true);
      onTapped?.();
    }
  };

  return {
    onContainerPointerDown,
    ref,
    setTapped,
    tapped,
  };
}
